import { useState } from "react";

const API_URL = "https://query-handler-869507078735.us-central1.run.app/concept";

const CONCEPTS = [
  { label: "Justice", icon: "⚖" },
  { label: "Virtue", icon: "🔥" },
  { label: "Happiness", icon: "☀" },
  { label: "The Soul", icon: "🌿" },
  { label: "Knowledge", icon: "👁" },
  { label: "Courage", icon: "🛡" },
  { label: "Death", icon: "🕊" },
  { label: "The Good Life", icon: "🌅" },
  { label: "Friendship", icon: "🤝" },
  { label: "Beauty", icon: "🌸" },
];

const PHILOSOPHERS = [
  { name: "Plato", icon: "⛑", color: "#C4A8F0", dim: "#8060B0", border: "#C4A8F066" },
  { name: "Aristotle", icon: "🏛", color: "#9FE1CB", dim: "#4DAA85", border: "#9FE1CB66" },
  { name: "Marcus Aurelius", icon: "⚔", color: "#FAC775", dim: "#B08040", border: "#FAC77566" },
];

const NODE_POSITIONS = [
  { x: 130, y: 68 },
  { x: 390, y: 68 },
  { x: 260, y: 268 },
];

export default function ConceptMap({ user }) {
  const [selected, setSelected] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activePhil, setActivePhil] = useState(null);

  async function fetchConcept(concept) {
  setSelected(concept);
  setData(null);
  setActivePhil(null);
  setLoading(true);
	  try {
		const token = await user.getIdToken();
		const res = await fetch(API_URL, {
		  method: "POST",
		  headers: {
			"Content-Type": "application/json",
			"Authorization": `Bearer ${token}`
		  },
		  body: JSON.stringify({ concept: concept.label }),
		});
		const json = await res.json();
		setData(json);
	  } catch (e) {
		console.error(e);
	  } finally {
		setLoading(false);
	  }
	}

  const cx = 260, cy = 185;

  return (
    <div style={styles.wrap}>
      <div style={styles.header}>
        <span style={styles.headerTitle}>CONCEPT MAP</span>
        <div style={styles.legend}>
          {PHILOSOPHERS.map(p => (
            <div key={p.name} style={styles.legItem}>
              <span style={{ fontSize: 13 }}>{p.icon}</span>
              <span style={{ ...styles.legLabel, color: p.dim }}>{p.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.graphWrap}>
        <svg viewBox="0 0 520 400" style={styles.svg}>
          <defs>
            <pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="1" cy="1" r="0.8" fill="#E8E0D008"/>
            </pattern>
          </defs>
          <rect width="520" height="400" fill="url(#dots)"/>

          <text x="14" y="20" fontSize="12" fill="#E8E0D015" fontFamily="serif">✦</text>
          <text x="496" y="20" fontSize="12" fill="#E8E0D015" fontFamily="serif">✦</text>
          <text x="14" y="395" fontSize="12" fill="#E8E0D015" fontFamily="serif">✦</text>
          <text x="496" y="395" fontSize="12" fill="#E8E0D015" fontFamily="serif">✦</text>
          <rect x="6" y="6" width="508" height="388" rx="3" fill="none" stroke="#E8E0D010" strokeWidth="1"/>

          {data && NODE_POSITIONS.map((pos, i) => (
            <line key={i}
              x1={cx} y1={cy}
              x2={pos.x + 60} y2={pos.y + 42}
              stroke={PHILOSOPHERS[i].color}
              strokeWidth="0.75"
              strokeOpacity="0.25"
              strokeDasharray="5 3"
            />
          ))}

          {/* Center node */}
          <rect x={cx - 60} y={cy - 48} width="120" height="96" rx="3"
            fill="#2A1545" stroke="#E8E0D0" strokeWidth="1.5"/>
          <line x1={cx - 60} y1={cy - 28} x2={cx + 60} y2={cy - 28}
            stroke="#E8E0D0" strokeWidth="0.5" strokeOpacity="0.35"/>
          {selected ? (
            <>
              <text x={cx} y={cy - 34} textAnchor="middle"
                fontFamily="Cinzel,serif" fontSize="7" fill="#E8E0D055" letterSpacing="0.15em">
                CONCEPT
              </text>
              <text x={cx} y={cy + 4} textAnchor="middle" fontSize="20">
                {selected.icon}
              </text>
              <text x={cx} y={cy + 24} textAnchor="middle"
                fontFamily="Cinzel,serif" fontSize="9.5" fill="#E8E0D0">
                {selected.label.toUpperCase()}
              </text>
              {loading && (
                <text x={cx} y={cy + 40} textAnchor="middle"
                  fontFamily="EB Garamond,serif" fontSize="8" fill="#7B5EA7" fontStyle="italic">
                  searching...
                </text>
              )}
            </>
          ) : (
            <>
              <text x={cx} y={cy - 34} textAnchor="middle"
                fontFamily="Cinzel,serif" fontSize="7" fill="#E8E0D030" letterSpacing="0.15em">
                CONCEPT
              </text>
              <text x={cx} y={cy + 8} textAnchor="middle"
                fontFamily="Cinzel,serif" fontSize="9" fill="#3A2A5A">
                SELECT BELOW
              </text>
            </>
          )}

          {/* Philosopher nodes */}
          {NODE_POSITIONS.map((pos, i) => {
            const p = PHILOSOPHERS[i];
            const hasData = data?.philosophers[p.name];
            return (
              <g key={p.name}
                style={{ cursor: data ? "pointer" : "default" }}
                onClick={() => data && setActivePhil(activePhil === p.name ? null : p.name)}>
                <rect x={pos.x} y={pos.y} width="120" height="84" rx="3"
                  fill={activePhil === p.name ? "#2A1545" : "#1E1035"}
                  stroke={activePhil === p.name ? p.color : p.border}
                  strokeWidth={activePhil === p.name ? 1.5 : 0.75}
                />
                <line x1={pos.x} y1={pos.y + 20} x2={pos.x + 120} y2={pos.y + 20}
                  stroke={p.color} strokeWidth="0.5" strokeOpacity="0.4"/>
                <text x={pos.x + 60} y={pos.y + 14} textAnchor="middle"
                  fontFamily="Cinzel,serif" fontSize="7.5" fill={p.color} letterSpacing="0.1em">
                  {p.name === "Marcus Aurelius" ? "MARCUS AUR." : p.name.toUpperCase()}
                </text>
                <text x={pos.x + 60} y={pos.y + 46} textAnchor="middle" fontSize="20">
                  {p.icon}
                </text>
                {hasData ? (
                  <text x={pos.x + 60} y={pos.y + 68} textAnchor="middle"
                    fontFamily="EB Garamond,serif" fontSize="8" fill={p.dim}>
                    {data.philosophers[p.name].ideas?.length || 0} ideas found
                  </text>
                ) : (
                  <text x={pos.x + 60} y={pos.y + 68} textAnchor="middle"
                    fontFamily="EB Garamond,serif" fontSize="8" fill="#3A2A5A">
                    {loading ? "searching..." : "awaiting query"}
                  </text>
                )}
              </g>
            );
          })}
        </svg>

        {activePhil && data?.philosophers[activePhil] && (() => {
          const p = PHILOSOPHERS.find(x => x.name === activePhil);
          const phil = data.philosophers[activePhil];
          return (
            <div style={styles.panel}>
              <div style={styles.panelHeader}>
                <span style={{ fontSize: 18 }}>{p.icon}</span>
                <span style={{ ...styles.panelTitle, color: p.color }}>{activePhil}</span>
              </div>
              <div style={styles.panelDivider} />
              <p style={styles.panelSummary}>{phil.summary}</p>
              {phil.ideas?.length > 0 && (
                <>
                  <div style={styles.sectionLabel}>KEY IDEAS</div>
                  {phil.ideas.map((idea, i) => (
                    <div key={i} style={styles.ideaRow}>
                      <span style={{ ...styles.ideaBullet, color: p.color }}>◆</span>
                      <span style={styles.ideaTxt}>{idea}</span>
                    </div>
                  ))}
                </>
              )}
              {phil.connections?.length > 0 && (
                <>
                  <div style={styles.sectionLabel}>CONNECTED TO</div>
                  {phil.connections.map((c, i) => (
                    <div key={i} style={{ ...styles.connTag, borderColor: p.border, color: p.dim }}>
                      {c}
                    </div>
                  ))}
                </>
              )}
            </div>
          );
        })()}
      </div>

      <div style={styles.chips}>
        {CONCEPTS.map(c => (
          <button key={c.label}
            style={{ ...styles.chip, ...(selected?.label === c.label ? styles.chipActive : {}) }}
            onClick={() => fetchConcept(c)}>
            <span style={styles.chipIcon}>{c.icon}</span>
            {c.label}
          </button>
        ))}
      </div>

      <div style={styles.hint}>
        {loading ? "Querying your RAG across all three philosophers..." :
         data ? "Click a philosopher tablet to reveal their ideas" :
         "Select a concept below to build the map from your texts"}
      </div>
    </div>
  );
}

const styles = {
  wrap: { background: "#1A0E2E", borderRadius: 12, border: "1.5px solid #E8E0D030", overflow: "hidden", fontFamily: "'EB Garamond', serif" },
  header: { padding: "0.875rem 1.25rem", borderBottom: "1.5px solid #E8E0D015", display: "flex", alignItems: "center", justifyContent: "space-between", background: "#150B28" },
  headerTitle: { fontFamily: "Cinzel, serif", fontSize: "0.8rem", color: "#E8E0D0", letterSpacing: "0.18em" },
  legend: { display: "flex", gap: "1.25rem" },
  legItem: { display: "flex", alignItems: "center", gap: 6 },
  legLabel: { fontSize: "0.72rem", fontFamily: "Cinzel, serif", letterSpacing: "0.05em" },
  graphWrap: { display: "flex", position: "relative", background: "#1A0E2E" },
  svg: { flex: 1, width: "100%" },
  panel: { width: 220, background: "#150B28", borderLeft: "1px solid #E8E0D015", padding: "1rem", overflowY: "auto", maxHeight: 400 },
  panelHeader: { display: "flex", alignItems: "center", gap: 8, marginBottom: "0.5rem" },
  panelTitle: { fontFamily: "Cinzel, serif", fontSize: "0.8rem", letterSpacing: "0.06em" },
  panelDivider: { height: "0.5px", background: "#E8E0D015", margin: "0.5rem 0 0.75rem" },
  panelSummary: { fontSize: "0.82rem", color: "#8070A8", lineHeight: 1.65, marginBottom: "0.75rem" },
  sectionLabel: { fontSize: "0.65rem", color: "#3A2A5A", letterSpacing: "0.15em", marginBottom: "0.4rem", marginTop: "0.5rem", fontFamily: "Cinzel, serif" },
  ideaRow: { display: "flex", gap: 6, alignItems: "flex-start", marginBottom: "0.4rem" },
  ideaBullet: { fontSize: "0.5rem", marginTop: 5, flexShrink: 0 },
  ideaTxt: { fontSize: "0.78rem", color: "#C0B8D8", lineHeight: 1.55 },
  connTag: { fontSize: "0.72rem", padding: "3px 10px", borderRadius: 10, border: "0.5px solid", marginBottom: 5, lineHeight: 1.4 },
  chips: { display: "flex", flexWrap: "wrap", gap: 6, padding: "0.875rem 1.25rem", borderTop: "1px solid #E8E0D010", background: "#150B28" },
  chip: { display: "flex", alignItems: "center", gap: 5, fontFamily: "'EB Garamond', serif", fontSize: "0.78rem", color: "#5A4070", padding: "4px 12px", border: "0.5px solid #2D2050", borderRadius: 14, cursor: "pointer", background: "transparent" },
  chipActive: { color: "#E8E0D0", borderColor: "#E8E0D055", background: "#7B5EA715" },
  chipIcon: { fontSize: 13 },
  hint: { padding: "0.6rem 1.25rem", fontSize: "0.72rem", color: "#3A2A5A", fontStyle: "italic", borderTop: "0.5px solid #E8E0D008", background: "#150B28", fontFamily: "Cinzel, serif", letterSpacing: "0.05em" },
};

